import { SET_PANEL } from './mutation-types';

const actions = {
    setPanels ({ commit, dispatch, state }, panels){
        if(panels){
            for(let e=0, elen=panels.length; e<elen; e++){
                let panel = panels[e];
                if(panel.id){
                    dispatch('setPanel', panel);
                }
            }
        }
    },
    setPanel ({ commit, state }, {id, ...params}){
        commit(SET_PANEL, {id, ...params});
    },
    openPanel ({ commit, state }, id){
        commit(SET_PANEL, {id, show: true});
    },
    closePanel ({ commit, state }, id){
        commit(SET_PANEL, {id, show: false});
    },
    togglePanel ({ commit, state, getters }, id){
        commit(SET_PANEL, {id, show: !getters.getPanelStatus(id)});
    },
    closeAllPanels ({ commit, state, getters }){
        let panels = getters.getPanels;
        for(let e=0, elen=panels.length; e<elen; e++){
            let panel = panels[e];
            if(panel.id){
                if(panel.showDefault !== undefined && panel.showDefault){
                    continue;
                }
                commit(SET_PANEL, {id: panel.id, show: false});
            }
        }
    },
};

export default actions;
